import {gql} from 'apollo-angular';

export const ADJUST_ITEM_QUANTITY = gql`
    mutation AdjustItemQuantity($id: ID!, $qty: Int!) {
        adjustOrderLineQuantity(orderLineId: $id, quantity: $qty) {
            order {
                id
                subTotal
                subTotalWithTax
                total
                totalWithTax
                totalQuantity
            }
            errorMessage
        }
    }
`;

export const REMOVE_ITEM_FROM_CART = gql`
    mutation RemoveItemFromCart($id: ID!) {
        adjustOrderLineQuantity(orderLineId: $id, quantity: 0) {
            order {
                id
            }
            errorMessage
        }
    }
`;
